import { passCodes } from '../passCodes';

export const step29door = {
    id: 29,
    title: 'Vrata',
    taskText: `
        <p>
            Odpovězte správně a posunte se dál. Odpovědi najdete někde v okolí.
        </p>
    `,
    cipher: {
        text: `
            <p>
                <b>4. otázka ze 4:</b>
            </p>
            <p>
                Tvar jaké číslice má klika na vratech?
            </p>
        `,
        label: 'Úkol',
    },
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[12],
    additionalInfo: 'Odpovědí je číslo',
    points: true,
    hints: [
        {
            text: 'Správná odpověď je 5',
        },
    ],
};
